<template>
  <svg
    aria-hidden="true"
    data-prefix="fal"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    class="w-6 h-6 fill-current"
  >
    <path
      d="M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ></path>
  </svg>
</template>
